"use client";
import { useEffect, useRef, useState } from 'react';

export const Canvas = ({ text }: { text: string }) => {
    const canvasRef = useRef<HTMLCanvasElement>(null);
    const [dimensions, setDimensions] = useState({ width: 300, height: 50 }); // Default size or your desired size

    useEffect(() => {
        const canvas = canvasRef.current;
        if (canvas) {
            const resizeCanvas = () => {
                // Set canvas dimensions
                canvas.width = dimensions.width;
                canvas.height = dimensions.height;

                const context = canvas.getContext('2d');
                if (context) {
                    // Your drawing code
                    context.clearRect(0, 0, canvas.width, canvas.height); // Clear previous rendering
                    context.font = '20px  Segoe UI'; // Adjust font size and family as needed
                    context.fillStyle = '#000000';
                    context.fillText(text, 0, 25); // Adjust positioning as needed
                }
            };

            resizeCanvas();
            // Optional: Adjust dimensions based on the window size or parent container
            // window.addEventListener('resize', resizeCanvas);
            // return () => window.removeEventListener('resize', resizeCanvas);
        }
    }, [text, dimensions]);

    return <canvas ref={canvasRef} className='w-full h-full blur-md bg-secondary' />;
};
